// generated from 41 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const purchaseCategoryFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("purchase_category_filter"),
  // Constants::Comparisons.boolean_comparisons (PurchaseCategoryFilter value field)
  comparison_key: z.enum(["1", "2"]),
  display_name: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 7 (17.07%), defined 34 (82.93%)
  raw_value: z
    .enum([
      "high likelihood", // 17 (50.00%)
      "medium likelihood", // 11 (32.35%)
      "low likelihood", // 6 (17.65%)
    ])
    .optional(),
  value: z.enum([
    "high likelihood", // 22 (53.66%)
    "medium likelihood", // 12 (29.27%)
    "low likelihood", // 7 (17.07%)
  ]),
  varies_by_app_group: z.literal(false),
});
